var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYearbuilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.66667V6.91667C0.585786 6.91667 0.25 7.25245 0.25 7.66667H1ZM11.375 1C11.375 0.585786 11.0392 0.25 10.625 0.25C10.2108 0.25 9.875 0.585786 9.875 1H11.375ZM9.875 4.33333C9.875 4.74755 10.2108 5.08333 10.625 5.08333C11.0392 5.08333 11.375 4.74755 11.375 4.33333H9.875ZM6.125 1C6.125 0.585786 5.78921 0.25 5.375 0.25C4.96079 0.25 4.625 0.585786 4.625 1H6.125ZM4.625 4.33333C4.625 4.74755 4.96079 5.08333 5.375 5.08333C5.78921 5.08333 6.125 4.74755 6.125 4.33333H4.625ZM0.25 14.3333C0.25 15.7021 1.40419 16.75 2.75 16.75V15.25C2.16281 15.25 1.75 14.8055 1.75 14.3333H0.25ZM2.75 16.75H13.25V15.25H2.75V16.75ZM13.25 16.75C14.5958 16.75 15.75 15.7021 15.75 14.3333H14.25C14.25 14.8055 13.8372 15.25 13.25 15.25V16.75ZM15.75 14.3333V7.66667H14.25V14.3333H15.75ZM15 6.91667H1V8.41667H15V6.91667ZM0.25 7.66667V14.3333H1.75V7.66667H0.25ZM1.75 14.3333V4.33333H0.25V14.3333H1.75ZM2.75 1.91667C1.40419 1.91667 0.25 2.96458 0.25 4.33333H1.75C1.75 3.86113 2.16281 3.41667 2.75 3.41667V1.91667ZM15.75 7.66667V4.33333H14.25V7.66667H15.75ZM13.25 3.41667C13.8372 3.41667 14.25 3.86113 14.25 4.33333H15.75C15.75 2.96458 14.5958 1.91667 13.25 1.91667V3.41667ZM13.25 1.91667H2.75V3.41667H13.25V1.91667ZM9.875 1V4.33333H11.375V1H9.875ZM4.625 1V4.33333H6.125V1H4.625Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearbuilt);
export default __webpack_public_path__ + "static/media/yearbuilt.353323c984281aec28d767f684666672.svg";
export { ForwardRef as ReactComponent };